import { render, staticRenderFns } from "./politica.vue?vue&type=template&id=5504db54&"
import script from "./politica.vue?vue&type=script&lang=js&"
export * from "./politica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports